import Vue from 'vue'
import Vuetify from 'vuetify'

import colors from 'vuetify/lib/util/colors'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
    theme: {
        dark: false,
        themes: {
          light: {
            primary: colors.purple,
            secondary: colors.grey.darken1,
            accent: colors.shades.black,
            error: colors.red.accent3,
          },
          dark: {
            
          },
        },
      },
    icons: {
        iconfont: 'mdi', // default - only for display purposes
        values: {
            heart: 'mdi-heart',
            heartoutline: 'mdi-heart-outline',
            bookmark: 'mdi-bookmark',
            bookmarkoutline: 'mdi-bookmark-outline',
            edit: 'mdi-image-edit',
            editoutline: 'mdi-image-edit-outline',
            flag: 'mdi-flag',
            flagoutline: 'mdi-flag-outline'

        },
       
    },
}

export default new Vuetify(opts)